<template>
  <div :class="classList">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'app-callout',
  props: {
    variant: {
      type: String,
    },
  },
  computed: {
    classList () {
      return [
        'callout',
        this.calloutVariant,
      ]
    },
    calloutVariant () {
      return this.variant ? `callout-${this.variant}` : ''
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Callout.vue?5985f3ce